import Styles from "./EventHeaderBatsFinal.module.scss";
import * as Event from "src/state/modules/event";
import { EventTime } from "../EventTime/EventTime";
import { FinalText } from "./components/FinalText";
import { GameClock } from "./GameClock";

interface EventHeaderBatsFinalProps {
  event: Event.Event;
  outcome: string;
  isLive?: boolean;
  liveLabel?: string;
  // First/last pitch times (epoch ms) for the game clock; first is null until the game has a pitch.
  firstPitchMs?: number | null;
  lastPitchMs?: number | null;
}

export function EventHeaderBatsFinal({
  event,
  outcome,
  isLive,
  liveLabel,
  firstPitchMs,
  lastPitchMs,
}: EventHeaderBatsFinalProps) {
  return (
    <div className={Styles.headerStack}>
      <div className={Styles.inlineHeader}>
        <EventTime event={event} />
        {isLive ? (
          <span className={Styles.liveStatus}>
            <span className={Styles.liveDot} />
            {liveLabel ? `LIVE · ${liveLabel}` : "LIVE"}
          </span>
        ) : (
          <FinalText text="Final" result={outcome} />
        )}
      </div>
      {firstPitchMs != null && (
        <GameClock firstPitchMs={firstPitchMs} lastPitchMs={lastPitchMs} isLive={isLive} />
      )}
    </div>
  );
}
